import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import moment from 'moment';

export const filtrarArray = (arr, filtro) => {
  const retorno = arr.filter(t => t !== filtro);
  retorno.sort();
  return retorno;
};

export const filtrarArrays = async (arr, filtro) => {
  let retorno = arr;
  // //
  // //
  await filtro.forEach(filtrar => {
    retorno = retorno.filter(t => t !== filtrar);
  })
  retorno.sort();
  return retorno;
};

export const mensagemTemporaria = (mensagem) => {
  toast.configure({
    autoClose: true,
    draggable: false,
    position: toast.POSITION.TOP_CENTER,
    hideProgressBar: true,
    newestOnTop: true,
    //etc you get the idea
  });
  toast.info(mensagem);
}

export const base64Encode = async (strTexto) =>{
  return Buffer.from(strTexto.toString()).toString('base64');
}

export const base64Decode = async (strTexto) =>{
  return Buffer.from(strTexto, 'base64').toString('utf8');
}

export const alerta = async (mensagem, tipoMensagem) => {
  /*
  0 - mensagem aviso
  1 - mensagem info
  2 - mensagem erro

 */

  toast.configure({
    autoClose: 5000,
    draggable: false,
    position: toast.POSITION.BOTTOM_CENTER,
    hideProgressBar: false,
    newestOnTop: true,

    //etc you get the idea
  });

  switch (tipoMensagem) {
    case 0:
      toast.warn(mensagem);
      break;
    case 1:
      toast.info(mensagem);
      break;
    case 2:
      toast.error(mensagem);
      break;
    default:
      toast.warn(mensagem);
    // code block
  }

};

export const tratarErros = (data) => {
  if (!data || data.error === undefined) {
    alerta('Erro não tratado.', 2);
    return;
  }
  if (data.error) {
    if (data.error === []) {
      alerta(data.message, 2);
      return;
    }
    if (data.error.parameters !== undefined) {
      alerta(data.message + "\n\n" + data.error.message, 2);
      return;
    } else {
      let erros = '';
      let cont = 1;
      try {
        data.error.forEach(err => {
          erros = erros + `${cont} - ${err}\n`;
          cont = cont + 1;
        })
        alerta(data.message + "\n\n" + erros, 1);
        return;
      } catch (error) {
        // //
        if (data.error.message.error !== undefined) {
          alerta(data.message + "\n\n" + data.error.message.error, 1);
        } else {
          if (data.message !== undefined) {
            alerta(data.message, 1);
          } else {
            alerta('Erro não tratado.', 1);
          }
        }
      }
    }
  }
}

export const inicializarObjeto = (objeto) => {
  if (objeto === undefined) {
    let obj = [];
    return obj;
  } else return objeto;
}

export const formatFloatBr = (valor, estilo = 'currency') =>{
  let retorno;
  //
  if (isNaN(valor) || valor == null){
    retorno = 0;
  } else {
    retorno = valor;
  }
  const formato = {};
  if (estilo === 'currency'){
    formato.style = 'currency';
  }
  formato.currency =  'BRL';
  formato.minimumFractionDigits =  2;
  formato.maximumFractionDigits =  2;

  retorno = retorno.toLocaleString('pt-BR', formato);
  //

  return retorno;
}

export const roundTwoDecimals = (numberToRoud) => {
  const rounded = Math.round(numberToRoud * 100) / 100;
  if (rounded === Infinity){
    return 0;
  }
  return rounded;
}

export const capitalize = (str, lower = false) =>
  (lower ? str.toLowerCase() : str).replace(/(?:^|\s|["'([{])+\S/g, match => match.toUpperCase());
;

export function getCurrentDate(separator = '/') {
  return moment().format('DD/MM/YYYY');
}

export function getCurrentTime(separator = '/') {
  return moment().format('HH:mm:ss');
}

export const isValidDate = function(data) {
  if (data === "" || data === undefined || data === null ) {
    return false;
  }
  moment.locale('pt-BR');
  const _data = moment(data, 'DD/MM/YYYY');
  //
  return _data._isValid;
};

export const formatOracleDateToBr = (data) =>{
  return moment(data).format('DD/MM/YYYY');
}
